import React, { useEffect, useState } from 'react';
import { fetchConToken } from '../../api/fetch';
import { Container, Modal } from 'react-bootstrap';
import LineChart from '../LineChart';
import { useContextInfo } from '../../context/ContextInfo';

const ModTraficTM = ({ show, onClose, id }) => {
    const [start, setStart] = useState(1);
    const [tr, setTr] = useState([]);
    const [cat, setCat] = useState([]);

    useEffect(() => {
        if (start > 0 && show) getData();
    }, [start, show]);

    const getData = async () => {
        const data = await fetchConToken(`networks/trafictr/${id}`);
        if (data.ok) {
            let tr2 = parseFloat(data.item.Mb);
            tr2 = tr2.toFixed(1);
            if (isNaN(tr2)) tr2 = 0;
            // Mantener solo los últimos 30 elementos en tr
            setTr((prevTr) => [...prevTr.slice(-29), tr2]);
            // Mantener solo los últimos 30 elementos en cat
            setCat((prevCat) => [...prevCat.slice(-29), data.item.name]);
        } else {
            setStart(0);
        }
        setTimeout(() => {
            setStart(start + 1);
        }, 2000);
    };
    const onHide = () => {
        setStart(1);
        onClose();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Body>
                <Container>
                    <LineChart cat={cat} data={tr} />
                </Container>
            </Modal.Body>
        </Modal>
    );
};

export default ModTraficTM;
